"use strict";
// See: https://blog.mgechev.com/2015/02/06/parsing-binary-protocol-data-javascript-typedarrays-blobs/#:~:text=The%20two%20possible%20values%20for,is%20the%20blob%20binary%20type.
Object.defineProperty(exports, "__esModule", { value: true });
exports.test = exports.rewind = exports.readStringLong = exports.writeStringLong = exports.readString = exports.writeString = exports.readVec2 = exports.writeVec2 = exports.readFloat = exports.writeFloat = exports.read32 = exports.write32 = exports.read16 = exports.write16 = exports.peek8 = exports.readBool = exports.writeBool = exports.readU8 = exports.read8 = exports.write8Unsigned = exports.write8 = exports.writeHeader = exports.create = void 0;
var text_encoding_shim_1 = require("text-encoding-shim");
var assert_sidecar_1 = require("../lib/assert-sidecar");
var lodash_1 = require("./lodash");
var ten = new text_encoding_shim_1.TextEncoder('utf-8');
var tdec = new text_encoding_shim_1.TextDecoder('utf-8');
var maxStringLength = 1024;
var maxLongStringLength = 1024 * 1024 * 10;
var use64bitFloats = true;
var defaultIsTextMode = false;
function create(isText, buff, buffSize) {
    if (isText === void 0) { isText = defaultIsTextMode; }
    if (buff === void 0) { buff = null; }
    if (buffSize === void 0) { buffSize = 1024 * 4; }
    if (!buff) {
        buff = new ArrayBuffer(buffSize);
    }
    var dv = new DataView(buff);
    var obj = {
        sv: '',
        buffer: buff,
        dataView: dv,
        offset: 0,
        isText: isText,
    };
    return obj;
}
exports.create = create;
function writeHeader(m, toMultiId) {
    //write16(m, toMultiId)
    write8Unsigned(m, toMultiId & 0xff);
    write8Unsigned(m, (toMultiId >> 8) & 0xff);
    // console.log(
    //   'write header',
    //   toMultiId,
    //   toMultiId & 0xff,
    //   (toMultiId >> 8) & 0xff,
    // )
}
exports.writeHeader = writeHeader;
function write8(m, v) {
    v = Math.floor(v);
    assert_sidecar_1.assert.assertIsByte(v);
    if (m.isText) {
        m.sv += v + '|';
        // console.log('test m.sv', m.sv)
    }
    else {
        m.dataView.setInt8(m.offset, v);
        m.offset++;
    }
}
exports.write8 = write8;
function write8Unsigned(m, v) {
    v = Math.floor(v);
    assert_sidecar_1.assert.assertIsByteUnsigned(v);
    if (m.isText) {
        m.sv += v + '|';
        // console.log('test m.sv', m.sv)
    }
    else {
        m.dataView.setInt8(m.offset, v);
        m.offset++;
    }
}
exports.write8Unsigned = write8Unsigned;
function read8(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = parseInt(m.sv.substring(m.offset, idx));
        // console.log('test m.sv r', idx, m.sv.substring(m.offset, idx), v)
        m.offset = idx + 1;
        return v;
    }
    else {
        var v = m.dataView.getInt8(m.offset);
        m.offset++;
        return v;
    }
}
exports.read8 = read8;
function readU8(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = parseInt(m.sv.substring(m.offset, idx));
        m.offset = idx + 1;
        return v;
    }
    else {
        var v = m.dataView.getUint8(m.offset);
        m.offset++;
        return v;
    }
}
exports.readU8 = readU8;
function writeBool(m, v) {
    if (m.isText) {
        m.sv += (v ? 't' : 'f') + '|';
    }
    else {
        m.dataView.setInt8(m.offset, v ? 1 : 0);
        m.offset++;
    }
}
exports.writeBool = writeBool;
function readBool(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = m.sv.substring(m.offset, idx) === 't';
        m.offset = idx + 1;
        return v;
    }
    else {
        var v = m.dataView.getInt8(m.offset);
        m.offset++;
        return v === 1;
    }
}
exports.readBool = readBool;
function peek8(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = parseInt(m.sv.substring(m.offset, idx));
        return v;
    }
    else {
        var v = m.dataView.getInt8(m.offset);
        return v;
    }
}
exports.peek8 = peek8;
function write16(m, v) {
    v = Math.floor(v);
    assert_sidecar_1.assert.assertIsInt16(v);
    if (m.isText) {
        m.sv += v + '|';
    }
    else {
        m.dataView.setInt16(m.offset, v, false);
        m.offset += 2;
    }
}
exports.write16 = write16;
function read16(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = parseInt(m.sv.substring(m.offset, idx));
        // console.log('test m.sv r', idx, m.sv.substring(m.offset, idx), v)
        m.offset = idx + 1;
        return v;
    }
    else {
        var v = m.dataView.getInt16(m.offset, false);
        m.offset += 2;
        return v;
    }
}
exports.read16 = read16;
function write32(m, v) {
    v = Math.floor(v);
    // assert.assertIsInt16(v)
    if (m.isText) {
        m.sv += v + '|';
    }
    else {
        m.dataView.setInt32(m.offset, v, false);
        m.offset += 4;
    }
}
exports.write32 = write32;
function read32(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = parseInt(m.sv.substring(m.offset, idx));
        m.offset = idx + 1;
        return v;
    }
    else {
        var v = m.dataView.getInt32(m.offset, false);
        m.offset += 4;
        return v;
    }
}
exports.read32 = read32;
function writeFloat(m, v) {
    if (m.isText) {
        m.sv += v + '|';
    }
    else {
        if (use64bitFloats) {
            m.dataView.setFloat64(m.offset, v, false);
            m.offset += 8;
        }
        else {
            m.dataView.setFloat32(m.offset, v, false);
            m.offset += 4;
        }
    }
}
exports.writeFloat = writeFloat;
function readFloat(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = parseFloat(m.sv.substring(m.offset, idx));
        m.offset = idx + 1;
        return v;
    }
    else {
        var v = 0;
        if (use64bitFloats) {
            v = m.dataView.getFloat64(m.offset, false);
            m.offset += 8;
        }
        else {
            v = m.dataView.getFloat32(m.offset, false);
            m.offset += 4;
        }
        return v;
    }
}
exports.readFloat = readFloat;
function writeVec2(m, v) {
    writeFloat(m, v.x);
    writeFloat(m, v.y);
}
exports.writeVec2 = writeVec2;
function readVec2(m) {
    var x = readFloat(m);
    var y = readFloat(m);
    return { x: x, y: y };
}
exports.readVec2 = readVec2;
function writeString(m, v) {
    v = v || '';
    if (m.isText) {
        m.sv += v + '|';
    }
    else {
        var encoded = ten.encode(v);
        var len = encoded.length;
        if (len > maxStringLength) {
            len = maxStringLength;
        }
        write16(m, len);
        if (len) {
            for (var i = 0; i < len; i++) {
                m.dataView.setUint8(m.offset + i, encoded[i]);
            }
            m.offset += len;
        }
    }
}
exports.writeString = writeString;
function readString(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = m.sv.substring(m.offset, idx);
        m.offset = idx + 1;
        return v;
    }
    else {
        var len = read16(m);
        if (!len) {
            return '';
        }
        var buff = m.buffer.slice(m.offset, m.offset + len);
        var decoded = tdec.decode(new DataView(buff));
        // console.log('decoded string', decoded)
        m.offset += len;
        return decoded;
    }
}
exports.readString = readString;
function writeStringLong(m, v) {
    v = v || '';
    if (m.isText) {
        m.sv += v + '|';
    }
    else {
        var encoded = ten.encode(v);
        var len = encoded.length;
        if (len > maxLongStringLength) {
            len = maxLongStringLength;
        }
        write32(m, len);
        if (len) {
            for (var i = 0; i < len; i++) {
                m.dataView.setUint8(m.offset + i, encoded[i]);
            }
            m.offset += len;
        }
    }
}
exports.writeStringLong = writeStringLong;
function readStringLong(m) {
    if (m.isText) {
        var idx = m.sv.indexOf('|', m.offset + 1);
        var v = m.sv.substring(m.offset, idx);
        m.offset = idx + 1;
        return v;
    }
    else {
        var len = read32(m);
        if (!len) {
            return '';
        }
        var buff = m.buffer.slice(m.offset, m.offset + len);
        var decoded = tdec.decode(new DataView(buff));
        // console.log('decoded string', decoded)
        m.offset += len;
        return decoded;
    }
}
exports.readStringLong = readStringLong;
function rewind(m) {
    m.offset = 0;
}
exports.rewind = rewind;
function test(msg, data, write, read) {
    var tf = [true, false];
    lodash_1.l.forEach(tf, function (c) {
        var m = create(c);
        write(m, data);
        rewind(m);
        var data2 = read(m);
        assert_sidecar_1.assert.deepEqSlow(data, data2, 'test message', msg);
    });
}
exports.test = test;
